const gqlImageFragment = `
id
url
altText
width
height
`

const gqlVariantFragment = `
id
title
availableForSale
compareAtPrice {
  amount
  currencyCode
}
price {
  amount
  currencyCode
}
selectedOptions {
  name
  value
}
image {
  id
  width
  height
  src
  altText
}
`;

const gqlProductPricesFragment = `
id
handle
priceRange {
  minVariantPrice {
    amount
    currencyCode
  }
  maxVariantPrice {
    amount
    currencyCode
  }
}
variants(first: 250) {
  edges {
    node {
      ${gqlVariantFragment}
    }
  }
}
`

export const gqlProductFragment = `
id
handle
title
createdAt
tags
productType
vendor
availableForSale
description
options(first: 250) {
  id
  name
  values
  optionValues {
    id
    name
    swatch {
      color
    }
  }
}
priceRange {
  minVariantPrice {
    amount
    currencyCode
  }
  maxVariantPrice {
    amount
    currencyCode
  }
}
images(first: 250) {
  edges {
    node {
      ${gqlImageFragment}
    }
  }
}
variants(first: 250) {
  edges {
    node {
      ${gqlVariantFragment}
    }
  }
}
collections(first: 10) {
  edges {
    node {
      handle
      title
    }
  }
}
technical_sheet: metafield(
  namespace: "custom"
  key: "technical_sheet"
) {
  file: reference {
    ... on GenericFile {
      id
      url
    }
  }
}
`
